import React from 'react';
// import PropTypes from 'prop-types';
import './Footer.css'
import FordLogo from '../../images/footer-logo.png'
import {footerContent, footerLinks} from '../../constants/footer.js'
import FooterSocialIcons from '../FooterSocialIcons'


class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <footer className="global-footer" >

        <div className="knotch-container" style={{width: '100%', maxWidth: 950, margin: '0 auto'}}>
          <div className="knotch_placeholder" data-width="100%" data-height="250px"></div>
        </div>
        <div id="ccpa-banner">
          <h2>
            California Residents
          </h2>
          <p>
            Exercise your rights under the California Consumer Privacy Act&nbsp;
            <a href="https://www.ford.com/help/privacy/ccpa/?ccpatype=deletemypi" style={{display: 'inline'}}>here</a>
          </p>
          <a className="ccpa-button" href="https://www.ford.com/help/privacy/ccpa/?ccpatype=donotsellmypi">
            Do Not  Sell My Personal Information
          </a>
        </div>
        <nav className="footer-container-one" >
          <ul>
            {footerContent.map((headerSection) => {
              return (
                <li key={headerSection.heading} className="footer-section">
                  <h4 className="footer-header">
                    <span>{headerSection.heading}</span>
                  </h4>
                  <div className="footer-links">
                    <ul>
                      {headerSection.links.map((headerLink) => {
                        return (
                          <li key={headerLink.heading} className="link-item">
                            <a className="footer-link" href={headerLink.href} target="_blank" rel="noopener noreferrer" onClick={this.props.trackClick('footer-link-click', headerLink.heading)}>{headerLink.heading}</a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </li>
              );
            })}
          </ul>
        </nav>
        <nav className="footer-container-two" >
          <h4> Connect </h4>
          <div>
            <a href="http://social.ford.com/" className="footer-link" target="_blank" rel="noopener noreferrer" onClick={this.props.trackClick('footer-link-click', 'social-url')}>social.ford.com</a>
          </div>
          <FooterSocialIcons />
        </nav>
        <nav className="footer-container-three">
          <ul>
            <li className="desktop-image">
              <a href="https://corporate.ford.com/homepage.html?intcmp=BFA-Microsite-FMC-CTA-20200515" onClick={this.props.trackClick('footer-link-click', 'logo')}>
                <img src={FordLogo} alt="Ford logo"/>
              </a>
            </li>
            {footerLinks.map((link) =>  {

              return link.heading.indexOf('Cookie') > -1 ? (
                <li key={link.heading}>
                  <a href={link.href} className="footer-link"  rel="noopener noreferrer" onClick={this.props.trackClick('footer-link-click', link.heading)}>
                {link.heading}
                </a>
              </li>) :
              (
                <li key={link.heading}>
                  <a href={link.href} className="footer-link" target="_blank" rel="noopener noreferrer" onClick={this.props.trackClick('footer-link-click', link.heading)}>
                {link.heading}
                </a>
              </li>
            )
          })}
          </ul>
        </nav>
      </footer>
    )
  }
}

// LoadingSpinner.defaultProps = {
// };
//
//
// LoadingSpinner.propTypes = {
// };
export default Footer;
